import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { QuotationInfo } from 'src/app/core/models/quotations-info.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-compare-product',
  templateUrl: './compare-product.component.html',
  styleUrls: ['./compare-product.component.scss']
})
export class CompareProductComponent {
  productDetails: any[] = [];
  coveragesList: any[] = [];
  quotationId: string = '';
  quotesInfo!: QuotationInfo;

  constructor(
    public loader: LoaderService,
    public fb: FormBuilder,
    private restService: RestService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private errorHandler: ErrorHandlerService,
  ) {
    this.route.params.subscribe(params => {
      this.quotationId = params['quotationId'];
    });
  }
  ngOnInit() {
    this.QuotationCompare();
    this.GetQuotesInfo();
  }
  
  GetQuotesInfo() {
    let params = {
      QuotationID: this.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/GetB2CQuotesInfo').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.quotesInfo = data.rObj.GetQuotesInfo;
            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  QuotationCompare() {
    let params = {
      QuotationID: this.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/QuotationB2CCompare').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.coveragesList = data.rObj.Coverages;
              this.productDetails = data.rObj.QuotationCompare.map((item: any) => ({
                ProductID: item.ProductID,
                ProductName: item.ProductName,
                coverageQuotesCompare: item.coverageQuotesCompare.reduce((acc: any, coverage: any) => {
                  acc[coverage.CoverageID] = coverage.additionalData.reduce((adAcc: any, ad: any) => {
                    adAcc[ad.AdditionalCoverageID] = ad.AdditionalCoverageDescriptionUserLimit;
                    return adAcc;
                  }, {});
                  return acc;
                }, {})
              }));



            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }
  goBack() {
    this.router.navigate(['quotation/quotation-premium', this.quotationId]);
  }
}